import styled from 'styled-components';
import Popup from 'reactjs-popup';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export const ShareMenu = styled(Popup)`
  width: 130px;
`;

export const ShareMenuPopup = styled.div``;

export const ShareTitle = styled(Paragraph)`
  color: #00c48b;
  font-size: 16px;
  font-weight: bold;
  display: inline-block;
  line-height: 0px;
  margin-left: 8px;
`;

export const ShareImg = styled(LazyLoadImage)`
  display: inline-block;
  vertical-align: middle;
`;
export const SocialIcon = styled(LazyLoadImage)`
  width: 24px;
  display: inline-block;
  vertical-align: middle;
  padding: 12px;
`;

export const ShareWrapper = styled.button`
  border: none;
  & :active {
    outline: none;
    border: none;
  }
  & :focus {
    outline: none;
    border: none;
  }
  & ::-moz-focus-inner {
    border: none;
    outline: none;
  }
  & ::-moz-active-inner {
    border: none;
    outline: none;
  }
  background: transparent;
  cursor: pointer;
`;
